import { object, string, date, array } from 'yup';
import { TEMPLATE_TYPES } from './template.constants';

const templateSchema = object({
  id: string(),
  created_on: date(),
  updated_on: date(),
  title: string().required(),
  subject: string().required(),
  body: string().required(),
  from_email: string().nullable(),
  to_emails: array().of(string()).nullable(),
  cc_emails: array().of(string()).nullable(),
  bcc_emails: array().of(string()).nullable(),
  company_id: string().required(),
  type: string().oneOf(Object.values(TEMPLATE_TYPES)).default(TEMPLATE_TYPES.DEFAULT),
  folder_id: string().nullable(),
});

export default templateSchema;
